import type { CountryLanguages } from '~/types/countryLanguages';
import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import { findCurrentSectionConfig } from '~/utils/findCurrentSectionConfig';
import { parseLocaleFromPath } from '~/utils/parseLocaleFromPath';

export function findSectionConfigForPath(
    registry: StoryblokConfigSlug[] | null | undefined,
    path: string,
    countryLanguages: CountryLanguages
): StoryblokConfigSlug | null {
    const locale = parseLocaleFromPath(path);
    if (!locale?.country || !locale.language) return null;

    return findCurrentSectionConfig(
        registry,
        path,
        `${locale.country}-${locale.language}`,
        locale.country,
        locale.language,
        countryLanguages
    );
}
